
<div class="d-flex gap-2" >
  <div style="width: 200px">
    <label class="f-small text-neutral-800 mb-1" for="selectActivityType">Activity Types</label>
    <app-customised-single-select id="selectActivityType" controlName="activityType" displayName="" [options]="activityOptions"
      [controls]="form?.controls" ></app-customised-single-select>
  </div>


  <div style="width: 200px">
    <label class="f-small text-neutral-800 mb-1" for="selectSelfAssessment">Activity</label>
    <app-customised-single-select id="selectSelfAssessment" controlName="activity" displayName="" [options]="options"
      [controls]="controls" ></app-customised-single-select>
  </div>
</div>
